var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyDash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: 17,
      height: 17,
      display: "block"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99999 12.2002C3.99999 11.5375 4.53725 11.0002 5.19999 11.0002L19.6 11.0002C20.2627 11.0002 20.8 11.5375 20.8 12.2002C20.8 12.8629 20.2627 13.4002 19.6 13.4002L5.19999 13.4002C4.53725 13.4002 3.99999 12.8629 3.99999 12.2002Z",
    fill: "#888DA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyDash);
export default __webpack_public_path__ + "static/media/grey-dash.9ad7b87a4ddf614c1ab67859842fea27.svg";
export { ForwardRef as ReactComponent };